
/**
 * Central configuration for API endpoints
 */

export const BASE_URL = 'https://backend-service-113709107751.us-central1.run.app'; //https://backend-service-113709107751.us-central1.run.app //http://localhost:8000
export const SITE_URL = 'https://sportlogin.app'; //https://sportlogin-frontend-dev.web.app //http://localhost //http://localhost:8080 
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51NKdW4I9RQ7unW0xQKWaRokWzn6KfwwcDMZWo6yaX5GZJxwLfbXNCBMCChiayxg5EZgPmcEEi4d0Dtczf7ZGIXVP00OxXOveOH'; //pk_live_51NKdW4I9RQ7unW0xQKWaRokWzn6KfwwcDMZWo6yaX5GZJxwLfbXNCBMCChiayxg5EZgPmcEEi4d0Dtczf7ZGIXVP00OxXOveOH
export const GOOGLE_MAPS_API_KEY = 'AIzaSyA0UK-vGwQUr0knLi6csU1r674MdLb4AzE'; // PROD: AIzaSyA0UK-vGwQUr0knLi6csU1r674MdLb4AzE
